import { render } from "./FormSettingsModal.vue?vue&type=template&id=4f715eb4&scoped=true"
import script from "./FormSettingsModal.vue?vue&type=script&lang=js"
export * from "./FormSettingsModal.vue?vue&type=script&lang=js"

import "./FormSettingsModal.vue?vue&type=style&index=0&id=4f715eb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f715eb4"]])

export default __exports__